// react components

//ReactEcharts
import ReactEcharts from "echarts-for-react";

// react-router-dom components

// mui components

// mui-icons components

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

//routes

//assets

//utils
import { AppendStatsToCharts } from "../../../utils/AppendStatsToCharts";

function HalfDoughnutCharts({ data = [] }) {
    const seriesData = AppendStatsToCharts(data);
    const allZero = seriesData.every((item) => item.value === 0);
    const displayData = allZero ? seriesData.map((item) => ({ ...item, value: 1 })) : seriesData;

    const option = {
        tooltip: {
            trigger: "item",
            confine: true,
            formatter: function (params) {
                const valueToShow = allZero ? 0 : params.value;
                let tooltipText = `<div style="text-align: left;">${params.name}: ${valueToShow}`;
                if (params.data.details) {
                    tooltipText += params.data.details.map((detail) => `<br/>${detail.name} : <span style={{fontWeight: 600}}>${detail.value}</span>`).join("");
                }
                tooltipText += `</div>`;
                return tooltipText;
            },
            textStyle: {
                fontSize: 12,
            },
        },
        legend: {
            top: "5%",
            left: "center",
            type: "scroll",
            selectedMode: false,
        },
        series: [
            {
                type: "pie",
                radius: displayData.length > 10 ? ["25%", "50%"] : ["35%", "60%"],
                center: displayData.length > 10 ? ["50%", "80%"] : ["55%", "80%"],
                startAngle: 180,
                endAngle: 360,
                data: displayData,
                label: {
                    show: true,
                    position: "outside",
                    distance: 5,
                    formatter: "{b}",
                    fontSize: displayData.length > 10 ? 9 : 11,
                    fontWeight: "normal",
                    alignTo: "labelLine",
                    lineHeight: displayData.length > 10 ? 11 : 15,
                    width: displayData.length > 10 ? 70 : 100,
                    overflow: "truncate",
                    ellipsis: "...",
                },
                labelLine: {
                    show: true,
                    length: displayData.length > 10 ? 10 : 20,
                    length2: displayData.length > 10 ? 10 : 20,
                    smooth: true,
                },
            },
        ],
    };

    return (
        <div style={{ overflow: "auto" }}>
            <ReactEcharts
                option={option}
                style={{ minWidth: "360px", height: "400px" }}
                opts={{ renderer: "svg" }}
            />
        </div>
    );
}

// Typechecking props for the HalfDoughnutCharts
HalfDoughnutCharts.propTypes = {
    // title: PropTypes.string,
    data: PropTypes.array,
};

export default HalfDoughnutCharts;
